import CONSUMER_ENGINE from "./urls";

export default [
  {
    appTitle: true,
    header: "Consumer Engine",
    icon: "fa-kit fa-hdp-app-consumer-engine",
    baseRoute: CONSUMER_ENGINE.baseUrl,
  },
  {
    header: "Identity Resolution",
    children: [
      {
        name: "Sources",
        route: CONSUMER_ENGINE.CONFIGURATION_SOURCES,
        permissions: ["entity_unification.view_source"],
      },
      {
        name: "Rule Sets",
        route: CONSUMER_ENGINE.CONFIGURATION_ENTITY_UNIFICATION,
        permissions: ["entity_unification.view_ruleset"],
      },
      {
        name: "Validators",
        route: CONSUMER_ENGINE.CONFIGURATION_FIELD_VALIDATOR,
        permissions: ["entity_unification.view_field_validator"],
      },
    ],
  },
  {
    header: "Golden Record",
    children: [
      {
        name: "Configuration",
        route: CONSUMER_ENGINE.CONFIGURATION_GOLDEN_RECORD,
        permissions: ["entity_unification.view_golden_record"],
      },
    ],
  },
  {
    header: "Operations",
    children: [
      {
        name: "Engine Job Monitoring",
        route: CONSUMER_ENGINE.OPERATIONS_MONITORING,
        permissions: ["entity_unification.view_data_ingestion_job"],
      },
      {
        name: "Web Form Mappings",
        route: CONSUMER_ENGINE.SURVEY_OUTPUT_MAPPING_SURVEYS,
        permissions: ["survey_output.view_survey"],
      },
      {
        name: "Web Form Models",
        route: CONSUMER_ENGINE.SURVEY_TARGET_MODEL_MANAGEMENT,
        permissions: ["survey_output.view_targetmodel"],
      },
      {
        name: "Consumer Populations",
        route: CONSUMER_ENGINE.CONSUMER_POPULATIONS,
        permissions: ["entity_unification.view_population_config"],
      },
    ],
  },
];
